module.exports = __webpack_public_path__ + "img/gofore.605c8c7d.svg";